import * as M from 'moment-timezone';
import * as R from 'ramda';

import { TelephoneNumber } from '@monjin/vue-toolkit/TelephoneInput/TelephoneInput';

import { ThumbnailUrl, Video } from '../model';

export const checkArray = R.ifElse(
    R.isNil,
    R.always([]),
    (x) => x
);

export function isNonEmptyArray(x: any): boolean {
    return checkArray(x).length > 0;
}


export function getPlaybackThumbnailUrls(baseUrl: string, video: Video): ThumbnailUrl {
    return {
        // Send thumbnail urls with prepended base url
        smallThumbnailUrl: buildResourceUrl(baseUrl, video.smallThumbnailUrl),
        mediumThumbnailUrl: buildResourceUrl(baseUrl, video.mediumThumbnailUrl),
        largeThumbnailUrl: buildResourceUrl(baseUrl, video.largeThumbnailUrl)
    };
}

export function buildResourceUrl(baseUrl: string, rawUrl: string = ''): string {
    return rawUrl ? baseUrl + rawUrl : rawUrl;
}

/**
 * @param str String in which you want to check whether given string present
 * @param subStr Substring that you want to find
 */
function _hasString(str: string = '', subStr: string = ''): boolean {
    return R.toLower(str).includes(R.toLower(subStr));
}

export const hasString = R.curry(_hasString);

export const PROFICIENCY = R.cond([
    [R.lte(5), R.always('Outstanding')],
    [R.lte(4), R.always('Excellent')],
    [R.lte(3), R.always('Proficient')],
    [R.lte(2), R.always('Competent')],
    [R.T, R.always('Beginner')]
]);

export interface HashTable<T> {
    [key: string]: T;
}

export const SVG_ICONS_FOR_SOFT_SKILLS: HashTable<string> = {
    Attitude: 'attitude',
    Communication: 'communication',
    Respect: 'respect',
    Agreeableness: 'agreeableness'
};

export const DEFAULT_SOFT_SKILL_ICON: string = 'attitude';

export const NON_TECHNICAL_SKILLS = [
    'Introduction',
    'Experience based',
    'Aspiration',
    'Attitude',
    'Quantitative Ability',
    'Verbal Ability',
    'Logical Reasoning'
];

export const SHOW_SEARCH_LIMIT = 4;

export const toMobileString = (contactNumber: TelephoneNumber): string => {
    let mobileNumber = '';

    if (contactNumber && contactNumber.dialNumber) {
        const dialCode = Number(contactNumber.dialCode);

        if (dialCode) {
            mobileNumber += `+${dialCode}` + '-';
        }

        mobileNumber += contactNumber.dialNumber;
    }

    return mobileNumber;
};

export const format = (date, f, timeZone) => M(date).tz(timeZone).format(f);

export const twoDigitNumber = (x) => x.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
